import { Card, CardContent } from '@/components/ui/card';
import {
  SectionHeading, EmptySection, Field, RiskBadge, StatusBadge, BoolBadge, TagList, formatTime,
} from './shared';

interface Props {
  data: any[];
}

export default function ActivitiesSection({ data }: Props) {
  return (
    <section>
      <SectionHeading id="section-activities" title="Activities" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="activities" />
      ) : (
        <div className="mt-2 space-y-3">
          {data.map((row: any, idx: number) => (
            <Card key={row.id}>
              <CardContent className="pt-4">
                <div className="mb-2 flex items-center gap-2">
                  <span className="text-xs font-medium text-muted-foreground">#{idx + 1}</span>
                  <StatusBadge status={row.status} />
                  <RiskBadge level={row.risk_level} />
                  {row.is_complete && (
                    <span className="rounded bg-mozaic-green/15 px-1.5 py-0.5 text-xs font-medium text-mozaic-green">
                      Complete
                    </span>
                  )}
                </div>
                <p className="mb-3 text-sm font-medium">{row.description}</p>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                  <Field label="Start Time" value={formatTime(row.start_time)} />
                  <Field label="End Time" value={formatTime(row.end_time)} />
                  <Field
                    label="Duration"
                    value={row.duration_minutes != null ? `${row.duration_minutes} min` : null}
                  />
                  <Field label="Crew Size" value={row.crew_size} />
                  <Field label="JSA Required" value={<BoolBadge value={row.is_jsa_required} />} />
                  <Field label="JSA Completed" value={<BoolBadge value={row.jsa_completed} />} />
                  <Field
                    label="Risk Factor Category"
                    value={
                      Array.isArray(row.risk_factor_category)
                        ? row.risk_factor_category.length > 0
                          ? <TagList tags={row.risk_factor_category} />
                          : null
                        : row.risk_factor_category
                    }
                  />
                  <div className="col-span-full">
                    <Field label="Risk Tags" value={<TagList tags={row.risk_tags} />} />
                  </div>
                  {row.risk_justification && (
                    <div className="col-span-full">
                      <Field label="Risk Justification" value={row.risk_justification} />
                    </div>
                  )}
                  {row.notes && (
                    <div className="col-span-full">
                      <Field label="Notes" value={row.notes} />
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
